import '@xyflow/react/dist/style.css';
import React from 'react';
import { EdgeProps, getBezierPath } from '@xyflow/react';
const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style = {},
  markerEnd,
  selected
}: EdgeProps) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });
  return <>
      <path id={id} style={style} className="react-flow__edge-path" d={edgePath} markerEnd={markerEnd} data-id="element-2" />
      {data?.label && <foreignObject width={250} height={40} x={labelX - 100} y={labelY - 20} className="edgebutton-foreignobject" requiredExtensions="http://www.w3.org/1999/xhtml" data-id="element-3">
          <div className="flex items-center justify-center h-full" data-id="element-4">
            <div className={`flex items-center px-3 py-1 text-xs bg-white border border-gray-200 rounded-full shadow-sm max-w-full ${selected ? 'border-blue-500' : ''}`} data-id="element-5">
              <span className="text-center leading-tight" data-id="element-6">{data.label}</span>
            </div>
          </div>
        </foreignObject>}
    </>;
};
export default CustomEdge;